import { isCanonicalPwaHost } from '@/lib/canonical-site';
import { isLikelyAutomatedUserAgent } from '@/lib/bot-user-agent';
import {
  getMobileStore,
  getPreferredStoreUrl,
} from '@/lib/constants/app-stores';
import { isPWA } from '@/framework/utils/site-utils';
import { isNativeApp } from '@/lib/utils/native-communication';

let didStartRetirement = false;

/**
 * People who installed the site before the manifest was removed still open it
 * in standalone mode. The browser will not delete that icon for us, so send
 * them to the native app instead of the shop.
 */
function redirectInstalledWebApp(): void {
  if (!isPWA() || isNativeApp()) {
    return;
  }

  const store = getMobileStore(navigator.userAgent);
  if (store === 'other') {
    const path = window.location.pathname;
    if (path === '/baixe-o-app' || path === '/baixe-o-app/') {
      return;
    }
    window.location.replace('/baixe-o-app/');
    return;
  }

  window.location.replace(getPreferredStoreUrl(navigator.userAgent));
}

/**
 * The previous worker (next-pwa) stays registered until /sw.js is updated in place.
 * Registering the replacement clears its caches. The same registration is kept,
 * so an existing Netcore push subscription is not dropped.
 * Crawlers skip registration — it was a source of rejected RUM errors.
 */
export function retireLegacyPwa(): void {
  if (typeof window === 'undefined' || didStartRetirement) {
    return;
  }
  didStartRetirement = true;

  const canRegisterServiceWorker =
    process.env.NODE_ENV === 'production' &&
    'serviceWorker' in navigator &&
    isCanonicalPwaHost() &&
    !isLikelyAutomatedUserAgent(navigator.userAgent);

  if (canRegisterServiceWorker) {
    void navigator.serviceWorker.register('/sw.js').catch(() => {
      // Avoid surfacing as an unhandled rejection.
    });
  }

  redirectInstalledWebApp();
}
